import { Page } from 'components';
import { useContext } from 'react';
import { Results } from './components';
import { assegneeSuggestionsContext } from './AssegneeSuggestionsContext';

let AssegneeSuggestions = () => {
    let { isLoading } = useContext(assegneeSuggestionsContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Assegnee suggestions"
            addNewUrl="/admin/AssegneeSuggestion/addnew"
        >
            <Results />
        </Page>
    )
}

export default AssegneeSuggestions;